export default "__VITE_ASSET__C24b9tSt__"